import { createSlice } from '@reduxjs/toolkit';
import { fetchEventStatusData } from '../actions/eventsAction';


const initialState = {
  eventStatusData: [],
  matchStatusOptions: [],
  loading: false,
  error: null,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    // Other synchronous reducers here...
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventStatusData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventStatusData.fulfilled, (state, action) => {
        state.loading = false;
        state.eventStatusData = action.payload.eventStatusData;
        state.matchStatusOptions = action.payload.statusOptions;
      })
      .addCase(fetchEventStatusData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { actions, reducer } = eventsSlice;
export default reducer;
